export default __webpack_public_path__ + "static/powered-by-pldt-9a561c4ac33a3d10749430d60745bc20.png";